import { render, staticRenderFns } from "./banner_add.vue?vue&type=template&id=868c20b2&scoped=true"
import script from "./banner_add.vue?vue&type=script&lang=js"
export * from "./banner_add.vue?vue&type=script&lang=js"
import style0 from "./banner_add.vue?vue&type=style&index=0&id=868c20b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868c20b2",
  null
  
)

export default component.exports